import {Button, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {useFloatingHeader} from '@yandex-delivery/utils/hooks'
import type {ReactElement} from 'react'

import {renderWidget} from '../index@desktop'
import type {ActionButtonWidgetProps as Props} from '../types'
import {useActionButtonProps} from './hooks'
import * as classes from './index@desktop.classes'

export function ActionButtonWidget(props: Props): ReactElement {
  const {sentinelRef} = props
  const {style, loading, size, handlePress, actionElement} = useActionButtonProps(props)
  const isFloatingSubmitButton = useFloatingHeader(sentinelRef)

  return (
    <Paper className={isFloatingSubmitButton ? classes.root : undefined} padding="S" radius="L">
      <Button
        disabled={!style.enabled}
        flexDirection="column"
        justifyContent={style.slot.align}
        loading={loading}
        onPress={handlePress}
        size={size}
        variant="action"
        fullWidth
      >
        {style.slot.title.items.map(renderWidget)}
        {style.slot.subtitle && style.slot.subtitle.items.map(renderWidget)}
        {actionElement}
      </Button>
    </Paper>
  )
}
